import angular from 'angular';

const merchantDetailStoreFactory = function merchantDetailStoreFactory(StoreStates, $log, Dispatcher, $rootScope) {
    "ngInject";
    let merchantDetail;
    let merchantDetailState = StoreStates.STORE_EMPTY;

    const notifyChange = function() {
      $rootScope.$broadcast("MERCHANT_DETAIL_UPDATE")
    };

		const notifyFail = function() {
			$rootScope.$broadcast("MERCHANT_DETAIL_FAIL");
		}

    Dispatcher.register(function(action) {
      switch (action.actionType) {
        case "MERCHANT_DETAIL_LOAD_ACTION":
          merchantDetail = action.data;
          merchantDetailState = action.state;
          notifyChange();
          break;
        case "MERCHANT_DETAIL_START_LOAD_ACTION":
          merchantDetailState = action.state;
          break;
        case "MERCHANT_DETAIL_ACTION_FAIL":
          merchantDetail = undefined;
          merchantDetailState = action.state;
					notifyFail();
          break;
        case "GLOBAL_CLEAN":
          merchantDetail = undefined;
          merchantDetailState = StoreStates.STORE_EMPTY;
          break;
        default:
          //noOp
      }
    });
    return {
      getMerchantDetail: function() {
        return angular.copy(merchantDetail);
      },
      getMerchantDetailState: function() {
        return merchantDetailState;
      },
      forceExpired: function() {
        merchantDetailState = StoreStates.STORE_EXPIRED;
      }
    }
  }

export default merchantDetailStoreFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/merchantDetailStore.factory.js
 **/